(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/newstt/assets/javascripts/views/news-tt-article.js') >= 0) return;  svs.modules.push('/components/statistics/newstt/assets/javascripts/views/news-tt-article.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.newstt = svs.statistics.newstt || {};
  svs.statistics.newstt.views = svs.statistics.newstt.views || {};

  svs.statistics.newstt.views.NewsTTArticle = svs.sport.news.views.NewsArticle.extend(
    {
      getTemplate: function() {
        return svs.statistics.newstt.templates.news_tt_article;
      },

      initialize: function(options) {
        this.options = _.extend(
          {
            tabIndex: 0
          },
          options
        );
        this.localStorageID += '-' + this.cid;
      },

      toggleExpand: function() {
        var content = this.ui.contentPanel,
          tempHeight,
          collapseHeight = 58;

        if (content.hasClass('collapsed')) {
          this.setStateClasses(true);

          tempHeight = this.getHeight(content);
          content.css('height', collapseHeight + 'px');

          content.animate(
            {
              height: tempHeight
            },
            200,
            function() {
              $(window.document).trigger('resizeTabView');
            }
          );
        } else {
          this.setStateClasses(false);

          content.css('height', this.getHeight(content) + 'px');

          content.animate(
            {
              height: collapseHeight
            },
            200,
            function() {
              $(window.document).trigger('resizeTabView');
            }
          );
        }
      },

      getHeight: function(content) {
        content.removeAttr('style');
        content.css('height', 100 + '%');
        return content.height();
      },

      onRender: function() {
        this.constructor.__super__.onRender.apply(this, []);
      },

      destroy: function() {
        this.options = null;
        this.constructor.__super__.destroy.apply(this, []);
      }
    }
  );
})(Backbone, _, svs);

 })(window);